


export function ddnyTitle(product, defaultName = '') {
	if(product?.vendor_style) {
		return product?.name ? `${product.name} (${product.vendor_style})` : product.vendor_style;
	} else if(product?.name) {
		return product.name;
	}
	return defaultName;
}

export function formatSku(val) {
	try {
		return (val || '').toUpperCase().trim();
	} catch(err) {
		console.error();
		return val;
	}
}

export function formatCurrency(val) {
	try {
		return Number(val).toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD',
		});
	} catch(err) {
		console.error();
		return val;
	}
}

export function normalizeCurrencyValue(val) {
	try {
		return parseFloat(val).toFixed(2).toString();
	} catch(err) {
		console.error();
		return val;
	}
}

export function ddnyThumbnailSrc(product) {
	if(!product?.media || !product.media.length) {
		return '/img/ddny/no-image.jpg';
	}
	for(const md of product.media) {
		if(md.file_type === 'image') {
			return ddnyMediaSrc(md);
		}
	}
	return '/img/ddny/no-image.jpg';
}

export function ddnyMediaSrc(media) {

	if(!media?.file_key) { 
		return '/img/ddny/no-image.jpg';
	}
	return `${process.env.REACT_APP_DDNY_IMG_URL}/${media.file_key}`;
}

export function ddnyFileTypeLabel(mediaType, singular = false) {
	switch(mediaType) {
		case 'image':
			return singular ? 'Image' : 'Images';
		case 'video':
			return singular ? 'Video' : 'Videos';
		case 'other':
			return singular ? 'Data file' : 'Data files';
		default:
			return singular ? 'Data file' : 'All files';
	}
}
